import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: "",
  loggedIn: false,
};
const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login(state, action) {
      state.loggedIn = true;
      state.userId = action.payload.token;
    },
    logout(state) {
      state.loggedIn = false;
      state.userId = "";
    },
  },
});

export const { login, logout } = LoginSlice.actions;
export default LoginSlice.reducer;
